import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {Store} from '@ngrx/store';

import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {DataSurveyState} from '../reducers/data-survey.reducers';
import {
  GetSurveyAction,
  GetSurveyFailedAction,
  GetSurveySuccessAction,
  GET_SURVEY, DELETE_SURVEY, DeleteSurveyAction, DeleteSurveyFailedAction, DELETE_SURVEY_SUCCESS,
  DeleteSurveySuccessAction, DeleteSurveySectionAction, DELETE_SURVEY_SECTION, DeleteSurveySectionFailedAction,
  DELETE_FIELD_QUESTION, DeleteFieldQuestionAction, DeleteFieldQuestionFailedAction,
} from '../actions/data-survey.actions';
import {catchError, map, mergeMap} from 'rxjs/operators';
import { DataSurveyService } from '../../services/data-survey.service';
import { SnackBarService } from '@core/services/snack-bar.service';
import { CommandService } from '@core/services/command.service';
import {DoNothingAction} from "@shared/store/actions/particle.actions";
import {PlatformToolDataSurveyHandler} from "../../services/platform-tool-data-survey.handler";

// For build purpose

@Injectable()
export class DataSurveyEffect {
  constructor(private dataSurveyStore: Store<DataSurveyState>,
              private snackBarService: SnackBarService,
              private dataSurveyService: DataSurveyService,
              private commandService: CommandService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private actions$: Actions,
              private platformToolDataSurveyHandler: PlatformToolDataSurveyHandler) {
  }


  GetSurvey$ = createEffect(() => this.actions$
    .pipe( ofType(GET_SURVEY) )
    .pipe(
      mergeMap((action: GetSurveyAction) => {
        return this.dataSurveyService.getSurvey(action.surveyId).pipe(
          map((payload: any) => {
            console.log('get survey effect:', payload);
            return new GetSurveySuccessAction(payload);
          }),
          catchError(error => {
            this.snackBarService.showError('Survey Fetching Failed');
            return of(new GetSurveyFailedAction(error));
          })
        );
      })
    ));


  DeleteSurvey$ = createEffect(() => this.actions$
    .pipe( ofType(DELETE_SURVEY) )
    .pipe(
      mergeMap((action: DeleteSurveyAction) => {
        const command = action.deleteSurveyCommand;
        this.fuseSplashScreenService.show();
        return this.commandService.executeCommand(command).pipe(
          map(deleteSurveySuccessNotification => {
            action.invalidateSubject.invalidate();
            this.platformToolDataSurveyHandler.onGridRowChanges();
            return new DeleteSurveySuccessAction(action.invalidateSubject);
          }),
          catchError(error => {
            this.fuseSplashScreenService.hide();
            this.snackBarService.showError('Survey delete Failed. Please try again later.');
            return of(new DeleteSurveyFailedAction(error));
          })
        );
      })
    ));


  DeleteSurveySection$ = createEffect(() => this.actions$
    .pipe( ofType(DELETE_SURVEY_SECTION) )
    .pipe(
      mergeMap((action: DeleteSurveySectionAction) => {
        const command = action.deleteSurveySectionCommand;
        this.fuseSplashScreenService.show();
        return this.commandService.executeCommand(command).pipe(
          map(deleteSurveySectionSuccessNotification => {
            return new GetSurveyAction(command.surveyId);
          }),
          catchError(error => {
            this.fuseSplashScreenService.hide();
            this.snackBarService.showError('Survey Section delete Failed. Please try again later.');
            return of(new DeleteSurveySectionFailedAction(error));
          })
        );
      })
    ));


  DeleteFieldQuestion$ = createEffect(() => this.actions$
    .pipe( ofType(DELETE_FIELD_QUESTION) )
    .pipe(
      mergeMap((action: DeleteFieldQuestionAction) => {
        const command = action.deleteFieldQuestionCommand;
        this.fuseSplashScreenService.show();
        return this.commandService.executeCommand(command).pipe(
          map(deleteFieldQuestionSuccessNotification => {
            return new GetSurveyAction(command.surveyId);
          }),
          catchError(error => {
            this.fuseSplashScreenService.hide();
            this.snackBarService.showError('Item delete Failed. Please try again later.');
            return of(new DeleteFieldQuestionFailedAction(error));
          })
        );
      })
    ));


  DeleteSurveySuccess$ = createEffect(() => this.actions$
    .pipe( ofType(DELETE_SURVEY_SUCCESS) )
    .pipe(
      map((action: DeleteSurveySuccessAction) => {
        action.invalidateSubject.invalidate();
        this.fuseSplashScreenService.hide();
        this.snackBarService.showInformation('Survey deleted');
        return new DoNothingAction();
      })
    ));

}
